import { GrapevineGroupEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineGroupEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineGroupEventsApi(configuration),
    [configuration]
  );
};
